import { ReactNode, useMemo } from 'react';
import PageLayout from './PageLayout';
import './LegalPageLayout.css';

export type LegalSection = {
  id: string;
  title: string;
};

type LegalPageLayoutProps = {
  title: string;
  updatedAt: string;
  version: string;
  sections: LegalSection[];
  children: ReactNode;
};

export default function LegalPageLayout({ title, updatedAt, version, sections, children }: LegalPageLayoutProps) {
  const toc = useMemo(() => sections.filter((s) => s.id && s.title), [sections]);

  return (
    <PageLayout title={title}>
      <div className="container legal-meta">
        <div className="legal-meta-card">
          <div className="legal-meta-row">
            <span className="legal-meta-label">Дата обновления</span>
            <span className="legal-meta-value">{updatedAt}</span>
          </div>
          <div className="legal-meta-row">
            <span className="legal-meta-label">Версия</span>
            <span className="legal-meta-value">{version}</span>
          </div>
          <div className="legal-meta-actions">
            <button
              type="button"
              className="legal-btn"
              onClick={() => window.print()}
            >
              Версия для печати
            </button>
          </div>
        </div>
      </div>

      <div className="container legal-grid">
        <aside className="legal-toc" aria-label="Содержание документа">
          <div className="legal-toc-title">Содержание</div>
          <ol className="legal-toc-list">
            {toc.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`} className="legal-toc-link">
                  {s.title}
                </a>
              </li>
            ))}
          </ol>
        </aside>

        <article className="legal-content">{children}</article>
      </div>
    </PageLayout>
  );
}

